import { mapState } from 'vuex';
import { get } from 'lodash';
import { debounce } from 'lodash';
import ApiService from '@/services/apiService';
import CoreN20Dialog from '@/components/core/n20Dialog.vue';
import CoreButton from '@/components/core/button.vue';
import CoreAccountSelector from '@/components/core/accountSelector.vue';
import CoreDtwinFinder from '@/components/core/dtwin/finder.vue';
export default {
  name: 'DigtialTwinTemplateCreateDialog',
  components: {
    CoreN20Dialog,
    CoreButton,
    CoreAccountSelector,
    CoreDtwinFinder
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    accounts: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      title: '',
      tenantId: get(this.accounts, '[0].id', null),
      parentTwinId: null,
      debouncedFetchParentTwinId: () => {},
      isSaving: false
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color']),
    saveDisabled() {
      return this.isSaving || !this.title || !this.tenantId || !this.parentTwinId;
    }
  },
  watch: {
    tenantId: {
      handler(value) {
        this.debouncedFetchParentTwinId(value);
      }
    }
  },
  created() {
    this.debouncedFetchParentTwinId = debounce(this.fetchParentTwinId, 500, {
      leading: true,
      trailing: false
    });
  },
  beforeDestroy() {
    if (this.debouncedFetchParentTwinId && this.debouncedFetchParentTwinId.cancel) {
      this.debouncedFetchParentTwinId.cancel();
    }
  },
  methods: {
    resetDialog() {
      this.title = '';
      this.tenantId = null;
      this.parentTwinId = null;
    },
    handleCloseDialog() {
      this.resetDialog();
      this.$emit('close');
    },
    async handleSave() {
      this.isSaving = true;
      await new Promise(resolve => setTimeout(resolve, 1250));
      this.$emit('save', {
        title: this.title,
        tenantId: this.tenantId,
        parentTwinId: this.parentTwinId
      });
      this.resetDialog();
      this.isSaving = false;
      this.$snack(this.$i18n_t('DigitalTwin.Templates.createDialog.success'));
    },
    fetchParentTwinId(tenantId) {
      if (!tenantId) {
        this.parentTwinId = null;
        return;
      }
      ApiService.digitalTwinFetchChildren(this, null, 0, 1, null, ['bare'], false, tenantId).then(res => {
        this.parentTwinId = get(res, 'digitaltwins[0].id', null);
      }).catch(err => {
        console.error(err);
      });
    }
  }
};